<template>
  <div class='time-log' :class="{'admin' : $store.getters.adminMode}" v-hotkey="keymap">
    <table class="search-bar">
      <tr>
        <td v-if="$store.getters.adminMode" width="30">
          <el-tooltip placement="top" content="Save Entries as CSV">
            <el-button class="download-entry-button" type="info" plain @click="saveAsCSV"><font-awesome-icon icon="download"  /> </el-button>
          </el-tooltip>
        </td>
        <td class="entry-search-td">
          <el-input v-model="searchInput" placeholder="Search" class="entry-search">
            <div slot="prepend" >
              <div v-if="searchTags.length === 0">
                <el-dropdown placement="bottom-start" trigger="click" @command="handleQueryClick">
                  <span class="el-dropdown-link">
                    <font-awesome-icon icon="caret-down"  />
                  </span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item v-if="$store.getters.timeEntryQueries.length === 0" :command="'clear'">No saved searches</el-dropdown-item>
                    <el-dropdown-item v-for="(query, index) in $store.getters.timeEntryQueries" :key="index" @click="handleQueryClick(query)" :command="query">
                      <el-tag v-for="(tag, index) in query.value" :key="index" @close="removeSearchTag(tag)" :type="tag.type">{{tag.value}}</el-tag>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="$store.getters.timeEntryQueries.length !== 0" :command="'clear'"><span class="clear-all-text">Clear All</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                
              </div>
              <div v-if="searchTags.length != 0">
                <span  @click="searchTags = []" class="clear-button">
                  <font-awesome-icon icon="times"  />
                </span>
                <el-tag closable v-for="(tag, index) in searchTags" :key="index" @close="removeSearchTag(tag)" :type="tag.type">{{tag.value}}</el-tag>
                <span class="save-button">
                    <font-awesome-icon  icon="heart" class="unsaved" @click="saveTimeEntryQuery" v-if="!currentSearchIsSaved"/>
                    <font-awesome-icon v-if="currentSearchIsSaved" icon="heart" class="saved" @click="removeTimeEntryQuery"/>
                </span>
              </div>
            </div>
            <div slot="suffix">
              <font-awesome-icon v-if="searchInput.length > 0" icon="times-circle" class="entry-search-icon clear" @click="searchInput = ''"/>
            </div>
          </el-input>
        </td>
        <td class='total-time-td'>
          <table>
            <tr>
              <td>
                <el-tooltip placement="top" content="Start new timer">
                  <el-button class="new-entry-button" type="success" plain @click="startNewTimer"><font-awesome-icon icon="play" /> </el-button>
                </el-tooltip>
              </td>
              <td>
                <el-tooltip placement="top" content="Create new entry">
                  <el-button class="new-entry-button" type="primary" plain @click="createNewTimeEntry"><font-awesome-icon icon="plus"  /> </el-button>
                </el-tooltip>
              </td>
              <td>
                <table>
                  <tr>
                    <td>
                      <h3 class="selected-entry-time">{{selectedEntryTotalTime}}h</h3>
                    </td>
                  </tr>
                  <tr v-if="$store.getters.adminMode">
                    <td>
                      <h3 class="selected-entry-time">${{selectedEntryTotalBill}}</h3>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <div class="table-row header">
      <div class="selected"><el-checkbox v-model="selectAllState" @change="selectAllEntries" :indeterminate="selectedEntries.length > 0 && selectedEntries.length < entries.length"></el-checkbox></div>
      <div class="date-time" @click="sortData('date')"><span>DATE/TIME<SortIcon column="date" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></span></div>
      <div class="duration" @click="sortData('duration')"><el-tooltip content="Duration" placement="top"><span>DUR</span></el-tooltip><SortIcon column="duration" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></div>
      <div class="rate" v-if="$store.getters.adminMode"><el-tooltip content="Billing rate" placement="top"><span>RATE</span></el-tooltip></div>
      <div class="total" v-if="$store.getters.adminMode"><el-tooltip content="Entry Total" placement="top"><span>TOTAL</span></el-tooltip></div>
      <div class="user" v-if="$store.getters.adminMode" @click="sortData('userName')">USER<SortIcon column="user" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></div>
      <div class="task"><span @click="sortData('taskString')">TASK<SortIcon column="taskString" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></span></div>
      <div class="activity"><span @click="sortData('currentActivityName')">ACTIVITY<SortIcon column="currentActivityName" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></span></div>
      <div class="description"><span @click="sortData('description')">DESCRIPTION<SortIcon column="description" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></span></div>
      <div class="submitted" @click="sortData('submitted')"><el-tooltip content="Submitted" placement="top"><font-awesome-icon icon="check" /></el-tooltip><SortIcon v-if="$store.getters.adminMode" column="submitted" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></div>
      <div class="locked"><span @click="sortData('locked')"><el-tooltip content="Locked" placement="top"><font-awesome-icon icon="lock"/></el-tooltip><SortIcon v-if="$store.getters.adminMode" column="locked" :sortProperty="$store.getters.timeEntrySortProp" :sortAscending="$store.getters.timeEntrySortAscending"></SortIcon></span></div>
      <div class="buttons"></div>
    </div>

    <RecycleScroller :items="entries" class="time-log-table" :item-height="30">
      <div slot-scope="{ item, index }" class="table-row" @click="editTimeEntry(item, $event)"   @contextmenu="handleRightClick(item)" :class="{'selected': currentRow == item, 
          'danger': !item.relationships.event.data && !item.relationships.milestone.data && !item.relationships.task.data && item.attributes.end, 'personal': item.isPersonal, 'pto': item.isPTO, 'holiday': item.isHoliday}">
        <div class="cell selected"><el-checkbox class="entry-checkbox" :value="item.selected" @change="selectEntry(item, $event, index)"></el-checkbox></div>
        <div class="cell date-time">
          <div class="date" size="mini">{{formatDateString(item.attributes.start)}}</div>
          <div class="time start tag" :class="[item.overlapsStart ? 'danger' : 'info']">{{formatTimeString(item.attributes.start)}}</div> -
          <div class="time end tag" :class="[!item.attributes.end || item.overlapsEnd ? 'danger' : 'info']">{{formatTimeString(item.attributes.end) || ' -- : --'}}</div>
        </div>
        <div class="cell duration"><div class="tag" :class="{'danger' : item.duration < 0.1 && !item.isPersonal, 'warning': item.duration > 6}">{{item.isPersonal ? '- - -' : item.duration}}{{ item.isPersonal? '': 'h'}}</div></div>
        <div class="cell rate" v-if="$store.getters.adminMode" >
          <span v-if="item.attributes.billingRate && item.activity">$</span>{{ item.attributes.billingRate && item.activity ? item.attributes.billingRate :  " - - -"}}
        </div> 
        <div class="cell total" v-if="$store.getters.adminMode">
          <div :class="{'warning-text' : item.activity && !item.activity.attributes.isBillable}" v-html="formatBillingTotal(item)">
          </div>
        </div>
        <div class="cell user" v-if="$store.getters.adminMode">{{item.user.attributes.name}}</div>
        <div class="cell task">
          <el-tooltip  :content="item.taskString" placement="top" :open-delay="tooltipDelay">
            <div>
              <div class="tag success" type="success" size="mini">{{item.client ? item.client : '- - -'}}</div>
              <div class="tag primary" size="mini">{{item.projectPath ? item.projectPath : '- - -'}}</div>
              <div class="tag" :class="{'warning' : item.task && item.task.type === 'events', 'info' : item.task && item.task.type === 'tasks' || !item.task}" size="mini">{{item.task ? item.task.attributes.name : '- - -'}}</div >
            </div>
          </el-tooltip>
        </div>
        <div class="cell activity">
          <el-tooltip  :content="item.activity ? item.activity.attributes.name : '- - -'" placement="top" :open-delay="tooltipDelay">
            <span :class="{'warning tag warning-text': !item.relationships.activity.data || item.activity !== item.defaultActivity}">{{item.activity ? item.activity.attributes.name : '- - -'}}</span>
          </el-tooltip>
        </div>
        <div class="cell description">
          <el-tooltip  :content="item.attributes.description" placement="top" :open-delay="tooltipDelay">
            <span>{{item.attributes.description}}</span>
          </el-tooltip>
        </div>
        <div class="cell submitted"><font-awesome-icon icon="check" class="submitted-icon" v-if="item.submitted"/></div>
        <div class="cell locked" ><font-awesome-icon icon="lock" class="locked-icon" v-if="item.locked"/></div>
        <div class="cell buttons">
          <button class="mini danger stop" @click="stopTimeEntry(item)" v-if="!item.attributes.end  && (!$store.getters.adminMode || item.user.id === $store.state.authentication.user.id)"><font-awesome-icon icon='stop' /></button>
          <button class="mini success" @click="startSimilarEntry(item)" v-if="item.attributes.end && !$store.getters.adminMode"><font-awesome-icon icon='play' /></button>
          <button class="mini primary" @click="copyTimeEntry(item)" v-if="item.attributes.end && !$store.getters.adminMode"><font-awesome-icon icon='plus' /></button>
          <button class="mini danger" @click="deleteTimeEntry(item)" v-if="item.attributes.end && !item.locked"><font-awesome-icon icon='times' /></button>
        </div>
      </div>
    </RecycleScroller>

    <el-dialog title="Start new timer" :visible.sync="showTaskDialog" top="50px" width="80%" :custom-class="'tasks-dialog'">
      <TaskTable v-bind="$props" :onSelect="selectTask" :isActivityVisible="$store.getters.adminMode" ref="taskTable"></TaskTable>
    </el-dialog>
    <context-menu id="context-menu" ref="ctxMenu" v-if="rightClickedEntry">
      <li @click="openTimeEntryInLP(rightClickedEntry)" v-if="rightClickedEntry">
        <el-button class="context-menu-button" size="mini" type="info" plain><font-awesome-icon icon='link' class="icon"/>Open task in LP</el-button>
      </li>
      <li @click="stopTimeEntry(rightClickedEntry)" v-if="rightClickedEntry && !rightClickedEntry.attributes.end && !$store.getters.adminMode">
        <el-button class="context-menu-button" size="mini" type="danger" plain><font-awesome-icon icon='stop' class="icon"/>Stop Now</el-button>
      </li>
      <li @click="startSimilarEntry(rightClickedEntry)" >
        <el-button class="context-menu-button" size="mini" type="success" plain><font-awesome-icon icon='play' class="icon"/>Start Similar</el-button>
      </li>
      <li @click="copyTimeEntry(rightClickedEntry)">
        <el-button class="context-menu-button" size="mini" type="primary" plain><font-awesome-icon icon='plus' class="icon"/> Copy Entry</el-button>
      </li>
      <li @click="deleteTimeEntry(rightClickedEntry)">
        <el-button class="context-menu-button" size="mini" type="danger" plain><font-awesome-icon icon="times" class="icon"/> Delete</el-button>
      </li>
    </context-menu>
  </div>
</template>

<script>
import TaskTable from '@/components/TaskTable'
import moment from 'moment'
import UserSelector from '@/components/UserSelector'
import SortIcon from '@/components/SortIcon'
import contextMenu from 'vue-context-menu'
import { EventHub } from '@/components/EventHub'
import { formatMoney } from '@/utils/utils'
import { formatDateString, getTimeEntryTask, startNewTimeEntry, setTimeEntryStopTime, setTimeEntryTask, formatTimeString } from '@/utils/timeEntry'
import { playSound } from '@/utils/sounds'

export default {
  props: {
    activities: Array,
    users: Array
  },
  components: {
    TaskTable,
    UserSelector,
    contextMenu,
    SortIcon
  },
  data () {
    return {
      searchTags: [
      ],
      multiEdit: {
        description: {
          visible: false,
          value: ''
        },
        task: {
          visible: false,
          value: ''
        },
        locked: {
          value: false
        },
        billed: {
          value: false
        },
        activity: {
          visible: false,
          activities: [],
          value: null
        }
      },
      rightClickedEntry: null,
      currentRow: null,
      isLoading: false,
      searchInput: '',
      showTaskDialog: false,
      showTimeEditPopover: false,
      lastIndex: null,
      selectAllState: false,
      activeTab: 'active',
      tooltipDelay: 700,
      shiftKey: false,
      lastSelected: null,
      selectedEntryTracker: []
    }
  },

  computed: {
    currentSearchIsSaved () {
      let ret = false
      let queries = this.$store.getters.timeEntryQueries

      queries.forEach(query => {
        if (JSON.stringify(query.value) === JSON.stringify(this.searchTags)) {
          ret = true
        }
      })
      return ret
    },
    entries () {
      // Parse the tags
      if (this.searchInput.endsWith(', ') || this.searchInput.endsWith('  ')) {
        let term = this.searchInput.slice(0, -2).trim()
        let type = ''
        let operator = 'and'
        this.searchInput = ''
        if (term.toLowerCase().match(/done:/) || term.toLowerCase().match(/onhold:/) || term.toLowerCase().match(/locked:/) || term.toLowerCase().match(/submitted:/)) {
          type = 'warning'
        }
        if (term.toLowerCase().startsWith('not ')) {
          type = 'danger'
          operator = 'not'
          term = term.substring(4)
        }
        if (term.toLowerCase().startsWith('or ')) {
          type = 'success'
          operator = 'or'
          term = term.substring(3)
        }
        if (term.toLowerCase().match(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])) to ([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/)) {
          type = 'info'
          operator = 'date'
        }

        let newTerm = {'value': term, 'type': type, 'operator': operator}
        let included = false
        this.searchTags.forEach(tag => {
          if (tag.value === term) {
            included = true
          }
        })
        if (!included && term !== '') {
          this.searchTags.push(newTerm)
        }
      }

      // Parse the terms
      let andTerms = []
      let orTerms = []
      let notTerms = []
      let dateTerms = []
      this.searchTags.forEach(term => {
        if (term.operator === 'or') { orTerms.push(term.value) }
        if (term.operator === 'and') { andTerms.push(term.value) }
        if (term.operator === 'not') { notTerms.push(term.value) }
        if (term.operator === 'date') { dateTerms.push(term.value) }
      })

      // Handle the date terms
      if (dateTerms.length === 1) {
        let dates = dateTerms[0].split(' to ')
        this.$store.commit('updateCurrentDateRange', dates)
      }

      let sortOrder = this.$store.getters.timeEntrySortAscending ? 1 : -1

      this.isLoading = false
      let ret = this.$store.getters.timeEntries.filter(entry => {
        let show = !(this.$store.getters.adminMode && entry.isPersonal)

        let includesAndTerms = andTerms.length > 0 ? getEntriesMatchingTerms(andTerms, true) : true
        let includesOrTerms = orTerms.length > 0 ? getEntriesMatchingTerms(orTerms, false) : false
        let includesNotTerms = notTerms.length > 0 ? getEntriesMatchingTerms(notTerms, false) : false

        function getEntriesMatchingTerms (terms, mustIncludeAll) {
          function filterTerm (term) {
            let termParts = term.toLowerCase().split(': ')
            let searchTerm = termParts.pop()
            let searchColumn = termParts.pop()
            let columnValues = []

            if (searchTerm === 'onhold:') {
              return entry.task.attributes.isOnHold
            } else if (searchTerm === 'done:') {
              return entry.task.attributes.isOnHold
            } else if (searchTerm === 'submitted:') {
              return entry.attributes.isSubmitted
            } else if (searchTerm === 'locked:') {
              return entry.attributes.isLocked
            } else {
              if (!searchColumn || searchColumn === 'client') columnValues.push(entry.client)
              if (!searchColumn || searchColumn === 'project') columnValues.push(entry.projectPath)
              if (!searchColumn || searchColumn === 'task') columnValues.push(entry.task ? entry.task.attributes.name : '')
              if (!searchColumn || searchColumn === 'activity') columnValues.push(entry.currentActivityName || '')
              if (!searchColumn || searchColumn === 'user') columnValues.push(entry.user.attributes.name)
              if (!searchColumn || searchColumn === 'description') columnValues.push(entry.attributes.description)
              if ((!searchColumn || searchColumn === 'rate') && entry.attributes.billingRate) columnValues.push(entry.attributes.billingRate.toString())
              if ((!searchColumn || searchColumn === 'tag') && entry.task && entry.task.attributes.tags) columnValues.push(entry.task.attributes.tags.join(' '))

              !searchColumn && columnValues.push(entry.description)
              !searchColumn && columnValues.push(formatDateString(entry.start))

              return !searchTerm || columnValues.some(columnValue => columnValue && columnValue.toLowerCase().includes(searchTerm))
            }
          }

          if (mustIncludeAll) {
            return terms.every(term => {
              return filterTerm(term)
            })
          } else {
            return terms.some(term => {
              return filterTerm(term)
            })
          }
        }

        return show && (includesAndTerms || includesOrTerms) && !includesNotTerms
      }).sort((a, b) => (a[this.$store.getters.timeEntrySortProp] > b[this.$store.getters.timeEntrySortProp]) ? sortOrder : ((b[this.$store.getters.timeEntrySortProp] > a[this.$store.getters.timeEntrySortProp]) ? (sortOrder * -1) : 0))

      let returnVal = []
      ret.forEach(entry => {
        if (this.selectedEntryTracker.includes(entry.id)) {
          entry.selected = true
        }
        entry.selected = entry.selected
        returnVal.push(entry)
      })
      this.$store.commit('updateFilteredEntries', returnVal)
      return returnVal
    },
    selectedEntries () {
      let entries = this.entries.filter(entry => entry.selected)
      return entries
    },
    selectedEntryTotalTime () {
      let entries = this.selectedEntries.length > 0 ? this.selectedEntries : this.entries
      let total = entries.reduce((total, entry) => total + (!entry.isPersonal ? Number(entry.duration) : 0), 0)

      return total.toFixed(1)
    },
    selectedEntryTotalBill () {
      let ret = 0.0
      let array = this.selectedEntries.length > 0 ? this.selectedEntries : this.entries || []
      array.forEach(entry => {
        if (entry.attributes.billingRate && entry.activity) {
          ret = Number(ret) + Number(Number(entry.attributes.billingRate) * Number(entry.duration))
        }
      })
      return formatMoney(ret)
    },
    keymap () {
      return {
        // bind to hotkey
        'ctrl+a': (e) => { this.handleCtrlA(e) },
        'enter': (e) => { this.handleEnter(e) },
        'escape': (e) => { this.handleEscape(e) },
        'delete': (e) => { this.handleDelete(e) },
        'backspace': (e) => { this.handleBackspace(e) }
      }
    },
    timeEditKeymap () {
      return {
        'enter': (e) => { this.handleEnter(e) }
      }
    },
    timeEntryFilters () {
      return this.$store.getters.timeEntryFilters
    }
  },

  watch: {
    timeEntryFilters: function () {
      this.$store.dispatch('time-entries/loadAll', this.$store.getters.timeEntryFilters)
    },
    selectedEntries: function (newVal, oldVal) {
      this.selectAllState = this.selectedEntries.length === this.entries.length && this.entries.length !== 0
    }
  },

  mounted () {
    EventHub.$on('clear-search', () => {
      this.searchInput = ''
    })
  },

  beforeDestroy () {
    EventHub.$off('clear-search')
  },

  methods: {
    handleQueryClick (query) {
      if (query === 'clear') {
        this.$store.commit('clearTimeEntryQueries')
      } else {
        this.searchTags = JSON.parse(JSON.stringify(query.value))
      }
    },
    removeSearchTag (tag) {
      this.searchTags.forEach((searchTag, index) => {
        if (tag.value === searchTag.value) {
          this.searchTags.splice(index, 1)
        }
      })
    },
    filterAutocomplete (queryString, cb) {
      var queries = this.$store.getters.timeEntryQueries
      var results = queryString ? queries.filter(query => (query.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)) : queries
      // call callback function to return suggestions
      cb(results.sort((a, b) => { return a.date < b.date }))
    },
    saveTimeEntryQuery () {
      this.$store.commit('saveTimeEntryQuery', this.searchTags)
    },
    removeTimeEntryQuery () {
      this.$store.commit('removeTimeEntryQuery', this.searchTags)
    },
    sortClass (column) {
      return this.$store.getters.timeEntrySortProp !== column ? 'sort' : this.$store.getters.timeEntrySortAscending ? 'sort-up' : 'sort-down'
    },

    /// /////////////////////////
    // Changing the time entry
    /// /////////////////////////

    openTimeEntryInLP (entry) {
      let workspaceId = String(this.$store.getters.workspaceId)
      let task = getTimeEntryTask(entry)
      if (window && window.process && window.process.type) {
        require('electron').shell.openExternal('https://app.liquidplanner.com/space/' + workspaceId + '/projects/show/' + task.id)
      } else {
        window.open('https://app.liquidplanner.com/space/' + workspaceId + '/projects/show/' + task.id)
      }
    },

    editTimeEntry (entry, e) {
      let user = this.$store.state.authentication.user
      let isAdminUser = user.role.attributes.name === 'admin'
      let entries = this.entries.filter(entry => entry.selected)
      let multiEdit = entries.length > 1
      let locked = multiEdit ? entries.some(entry => entry.locked) : entry.locked
      let restricted = multiEdit ? entries.some(entry => entry.user.id !== user.id) && !isAdminUser : entry.user.id !== user.id && !isAdminUser

      if (e.target.closest('button, .selected')) {
        return
      }

      if (restricted) {
        this.$alert(`${multiEdit ? 'One or more selected time entries are' : 'This time entry is'} restricted. Editing is not available.`, 'Time Entry Restricted', {
          confirmButtonText: 'OK',
          type: 'warning'
        })
        return
      }

      if ((locked && !this.$store.getters.adminMode)) {
        this.$alert(`${multiEdit ? 'One or more selected time entries are' : 'This time entry is'} locked. Editing is not available.`, 'Time Entry Locked', {
          confirmButtonText: 'OK',
          type: 'warning'
        })
        return
      }

      let cell = e.target.closest('.cell')
      let focus = cell ? cell.className.includes('date-time') ? e.target.className.includes('date') ? 'date' : e.target.className.includes('start') ? 'start' : 'end' : cell.className.split(' ').pop() : null
      let params = {
        title: `Edit Time ${multiEdit ? 'Entries' : 'Entry'}`,
        entries: multiEdit ? entries : [entry],
        focus: !multiEdit || (multiEdit && ['description', 'activity', 'task'].includes(focus)) ? focus : null,
        save: this.saveTimeEntry
      }
      EventHub.$emit('show-new-entry-dialog', params)
    },

    saveTimeEntry (entry) {
      if (!entry.id) {
        this.$store.dispatch('time-entries/create', entry).then(() => {
          playSound('positive')
        })
      } else {
        this.$store.dispatch('time-entries/update', entry).then(() => { this.$store.dispatch('time-entries/loadById', { id: entry.id }) })
      }
    },

    createNewTimeEntry () {
      let adminMode = this.$store.getters.adminMode
      let params = {
        title: 'Create New Entry',
        entries: [
          {
            date: moment(),
            start: moment(),
            end: moment(),
            user: !adminMode ? this.$store.getters['users/byId']({ id: this.$store.state.authentication.user.id }) : null
          }
        ],
        focus: 'task',
        save: this.saveTimeEntry
      }
      EventHub.$emit('show-new-entry-dialog', params)
    },

    copyTimeEntry (entry) {
      let copy = JSON.parse(JSON.stringify(entry))
      copy.date = moment()
      copy.start = moment()
      copy.end = moment()
      copy.attributes.isLocked = false
      copy.attributes.isSubmitted = false
      copy.locked = false
      copy.submitted = false
      delete copy.id
      let params = {
        title: 'Copy Time Entry',
        entries: [copy],
        save: this.saveTimeEntry
      }

      EventHub.$emit('show-new-entry-dialog', params)
    },

    startNewTimer () {
      this.currentRow = null
      this.showTaskDialog = true
      this.$nextTick(() => this.$refs.taskTable.$refs.task.focus())
    },

    stopTimeEntry (entry, input) {
      this.selectCurrentRow()
      let time = input || 'now'
      setTimeEntryStopTime(entry, time)
      playSound('negative')
    },
    deleteTimeEntry (entry, multi) {
      if (multi) {
        this.$store.dispatch('time-entries/delete', entry)
      } else {
        this.$confirm('Are you sure you want to delete this entry?').then(_ => {
          this.$store.dispatch('time-entries/delete', entry)
        }).catch(_ => {})
      }
    },
    startSimilarEntry (entry) {
      startNewTimeEntry(getTimeEntryTask(entry), 'now', entry.attributes.description)
    },
    sortData (prop, order) {
      if (prop === this.$store.getters.timeEntrySortProp) {
        this.$store.commit('toggleTimeEntrySortAscending')
      } else {
        this.$store.commit('setTimeEntrySortAscending', true)
      }
      this.$store.commit('setTimeEntrySortProp', prop)
    },
    setTimeEntryStopTime: setTimeEntryStopTime,

    /// /////////////////////////
    // UI tasks
    /// /////////////////////////

    saveAsCSV () {
      let csvContent = 'data:text/csv;charset=utf-8,'
      let row = 'StartDate,Start Time,End Time,Duration,Billing Rate,Billable Total,Non-Billable Total,User,Task,Activity,Description'
      csvContent += row + '\r\n'
      let array = this.selectedEntries.length > 0 ? this.selectedEntries : this.entries || []
      array.forEach(function (entry) {
        let billingRate = entry.attributes.billingRate > 0 ? formatMoney(entry.attributes.billingRate) : ''
        let billableTotal = entry.activity ? entry.activity.attributes.isBillable ? formatMoney(Number(entry.attributes.billingRate) * Number(entry.duration)) : '' : ''
        let nonBillableTotal = entry.activity ? !entry.activity.attributes.isBillable ? formatMoney(Number(entry.attributes.billingRate) * Number(entry.duration)) : '' : ''
        if (nonBillableTotal < 1) {
          nonBillableTotal = ''
        }
        let user = entry.user ? entry.user.attributes.name : '- - -'
        let activity = entry.activity ? entry.activity.attributes.name : '- - -'
        let row = moment(entry.date).format('YYYY-MM-DD') + ',' + moment(entry.start).format('HH:mm') + ',' + moment(entry.end).format('HH:mm') + ',' + entry.duration + ',' + billingRate + ',' + billableTotal + ',' + nonBillableTotal + ',' + user + ',' + entry.taskString.replace(/,/g, '') + ',' + activity + ',' + entry.description.replace(/,/g, '')
        csvContent += row + '\r\n'
      })
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'flux_export.csv')
      document.body.appendChild(link) // Required for FF

      link.click()
    },

    tableRowClassName ({row, rowIndex}) {
      let classlist = 'time-log-entry-row'
      if (!row.attributes.end) {
        classlist += ' current-task'
      }
      return classlist
    },

    selectTask (task) {
      if (this.currentRow) {
        let row = JSON.parse(JSON.stringify(this.currentRow))
        setTimeEntryTask(row, task)
        this.showTaskDialog = false
        this.selectCurrentRow(row)
      } else {
        startNewTimeEntry(task, 'now')
        this.showTaskDialog = false
      }
    },
    multiSelectTask (task) {
      this.multiEdit.task.value = task
    },
    selectCurrentRow (row) {
      const newRow = row === this.currentRow ? null : row
      this.currentRow = newRow
    },
    formatBillingTotal (entry) {
      if (entry.attributes.billingRate && entry.activity) {
        let ret = String((Number(entry.attributes.billingRate) * Number(entry.duration)).toFixed(0))
        if (ret.length < 4) {
          for (let i = 0; i < 4 - ret.length; i++) {
            ret = '&nbsp' + ret
          }
        }
        return '$' + ret
      } else {
        return ' - - - '
      }
    },

    /// ///////////////////////
    // Event Handlers
    /// ///////////////////////

    handleRowClick (entry, e) {
      if (!e.target.closest('.buttons') && !e.target.closest('.entry-checkbox')) {
        if (!entry.locked && this.selectedEntries.length === 0) {
          this.currentRow = entry
        }
      }
    },

    handleGlobalClick (e) {
      this.shiftKey = e.shiftKey
      if ((!e.target.closest('.time-log-table') && !e.target.closest('.tasks-table'))) { // If the click is outside the table and the popover is not shown
        this.selectCurrentRow()
      }
    },
    handleEnter (event, param) {
      if (event.target.placeholder === 'Search' && this.searchInput.length > 0) {
        this.searchInput = this.searchInput + ', '
      }
      if (event.target.localName === 'input') {
        this.selectCurrentRow()
      }
    },
    handleEscape (event, param) {
      if (event.target.placeholder === 'Search') {
        this.searchTags = []
        this.searchInput = ''
      }
      if (event.target.localName !== 'input') {
        this.selectCurrentRow()
      } else {

      }
    },
    handleBackspace (event, param) {
      if (event.target.placeholder === 'Search' && this.searchInput === '') {
        this.searchTags.splice(-1, 1)
      }
    },
    handleDelete (event, param) {
      let multipleSelection = []
      this.entries.forEach(entry => {
        if (entry.selected) {
          multipleSelection.push(entry)
        }
      })
      if (multipleSelection.length) {
        let isPlural = multipleSelection.length > 1
        this.$confirm(multipleSelection.length + ' task' + (isPlural ? 's' : '') + ' selected. Are you sure you want to delete ' + (isPlural ? 'them' : 'it') + '?').then(_ => {
          this.isLoading = true
          multipleSelection.forEach(entry => {
            this.deleteTimeEntry(entry, true)
          })
          multipleSelection = []
          this.isLoading = false
        }).catch(_ => {})
      }
    },
    handleCtrlA (event, param) {
      if (event.target.className !== 'el-input__inner') {
        this.selectAllEntries(true)
      }
    },
    selectEntry (entry, value, start) {
      this.selectedEntryTracker = []
      entry.selected = value

      if (!this.lastSelected || !this.entries.includes(this.lastSelected)) {
        this.lastSelected = entry
        return
      }

      if (this.shiftKey) {
        let end = this.entries.indexOf(this.lastSelected)

        this.entries.slice(Math.min(start, end), Math.max(start, end) + 1).forEach(entry => {
          entry.selected = this.lastSelected.selected
        })
      }

      this.entries.forEach(entry => { // Update the tracker
        if (entry.selected) {
          this.selectedEntryTracker.push(entry.id)
        }
      })

      this.lastSelected = entry
    },

    selectAllEntries (value) {
      this.selectedEntryTracker = []
      this.entries.forEach(entry => {
        entry.selected = value
        if (value) {
          this.selectedEntryTracker.push(entry.id)
        }
      })
    },

    handleRightClick (entry) {
      this.rightClickedEntry = entry
      if (this.$refs && this.$refs.ctxMenu) {
        this.$refs.ctxMenu.open()
      }
    },

    /// /////////////////////////
    // Formatters
    /// /////////////////////////

    formatTimeString: formatTimeString,
    formatDateString: formatDateString
  },
  created () {
    document.addEventListener('click', this.handleGlobalClick)
  },
  destroyed () {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>

<style lang='scss'>
@import '../styles/common.scss';

.el-time-panel{
  display: none;
}
.admin{
  .submitted, .locked {
    width:35px !important;
  }
  .buttons {
    width: 30px !important;
  }
}
.time-log {
  padding: 20px !important;
  height: 100%;
  box-sizing: border-box;

  .submitted-icon{
    color: $success-color;
  }
  .vue-recycle-scroller__item-view {
    width: initial !important;
    height: 31px;
    right: 0px;
  }
  .time-log-table {
    height: calc(100vh - 215px);
    color: #606266;

    .activity{
      color: rgb(163, 163, 163);
    }
  }
  .warning-text{
    color:$warning-color !important;
    
  }
  .table-row {
    display: table;
    table-layout: fixed;
    border-bottom: 1px solid $table-border-color;
    height: 30px;
    width: 100%;

    > div {
      display: table-cell;
      white-space: nowrap;
      vertical-align: middle;
      border-right: 5px solid transparent;
    }
    &.header {
      font-weight: bold;
      color: gray;
      text-transform: uppercase;
      height: 25px;
      margin-top: 10px;

      button {
        width: 25px;
        height: 22px;
        padding: 2px;
      }
    }
    &:hover {
      background: $table-hover-color;

      .buttons button {
        display: initial;
      }
    }
    &.selected {
      background: $table-selected-color;
    }
    &.current-task {
      background: rgb(236, 245, 255) !important;
    }
    &.locked {
      background:$table-hover-color !important;
    }
    &.personal {
      background:$personal-color !important;
      font-style: italic;
    }
    &.pto{
      background:$pto-color !important;
      font-style: italic;
    }
    &.holiday {
      background:$holiday-color !important;
      font-style: italic;
    }
    &.danger {
      background: $error-background-color !important;
      border: none;
    }
    &.warning {
      color: $warning-color !important;
    }
    .selected {
      width: 25px;
    }
    .date-time {
      width: 180px;
    }
    .duration {
      width: 50px;
      text-align: center;

      .tag {
        width: 35px;
      }
    }
    .rate {
      width: 40px;
    }
    .total {
      width: 50px;
    }
    .user {
      width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .task {
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .submitted {
      width: 20px;
    }
    .locked {
      width: 20px;
      color: gray;
    }
    .activity {
      padding:0px 4px !important;
      width: 60px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .description {
      width: 15%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .buttons {
      width: 100px;
      text-align: right;

      button {
        width: 30px;
        height: 22px;
        display: none;
        padding: 2px 7px;
      }
      .stop {
        display: initial;
      }
    }
    .date{
      display: inline-block;
      width: 80px;
    }
    .time{
      width: 35px;
    }    
  }
  .search-bar {
    .selected-entry-time {
      float: right;
      padding:0px !important;
    }

    width:100%;

    .selected-entry-time {
      color: gray;
      padding: 10px 0px;
    }

    .new-entry-button{
      margin:0px;
    }

    .total-time-td {
      width: 250px !important;
    }

    .entry-search-td {


      .entry-search {
        width: 100%;

        .entry-search-icon {
          padding: 12px;
          &
          &.clear{
            padding-right:0px;
          }
        }
      
      }
    }
  }
}

.clear-button{
  padding-right:15px;
  margin-bottom:-5px;
}
.save-button{
  margin-left:10px;
}
.saved{
  color:$light-red;
}
.use-query-icon{
  
  color:green !important;
}
.remove-query-icon{
  color:$light-red !important;
}
.clear-all-text{
  font-style: italic;
  color: gray;
}

.context-menu-button{
  width:calc(100% - 10px);
  height:22px;
  padding:1px !important;
  margin:2.5px 5px!important;
  .icon{
    float:left;
    padding-left:10px;
  }
}

.el-dialog {
  
  &.tasks-dialog {
    max-width: 1000px;
  }
}
</style>






